import { CrudList } from '../shared/CrudPage';
import { unitService } from '@kss/api';
import type { Unit, UnitCreate, UnitFilter } from '@kss/api';
import { StatusBadge } from '@kss/ui';

export default function AllUnits() {
  return (
    <CrudList<Unit, UnitCreate, UnitFilter>
      title="Units of measure"
      newLabel="New unit"
      service={unitService}
      idKey="unitId"
      labelKey="name"
      basePath="/panel/units"
      columns={[
        { accessor: 'code', title: 'Code', sortable: true, filterable: true, width: 120 },
        { accessor: 'name', title: 'Name', sortable: true, filterable: true },
        { accessor: 'precision', title: 'Precision', width: 100, render: (r) => r.precision ?? '—' },
        {
          accessor: 'isActive',
          title: 'Status',
          width: 110,
          render: (r) => <StatusBadge status={r.isActive ? 'active' : 'inactive'} />,
        },
      ]}
    />
  );
}
